interface Props {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  light?: boolean;
  centered?: boolean;
  className?: string;
  /** h1 quand le titre est le titre principal de la page */
  as?: 'h1' | 'h2';
}

export default function SectionTitle({
  eyebrow,
  title,
  subtitle,
  light = false,
  centered = true,
  className = '',
  as: Heading = 'h2',
}: Props) {
  return (
    <div className={`${centered ? 'text-center' : ''} ${className}`}>
      {eyebrow && (
        <p
          className={`font-sans text-xs tracking-[0.25em] uppercase mb-4 ${
            light ? 'text-cream-200/70' : 'text-forest-light'
          }`}
        >
          {eyebrow}
        </p>
      )}
      <Heading
        className={`font-serif text-4xl md:text-5xl font-light leading-tight mb-5 ${
          light ? 'text-cream-100' : 'text-forest-dark'
        }`}
      >
        {title}
      </Heading>
      {subtitle && (
        <p
          className={`font-sans text-base md:text-lg leading-relaxed ${
            centered ? 'mx-auto' : ''
          } max-w-xl ${light ? 'text-cream-100/60' : 'text-forest/70'}`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
